export const WEEK_DAY_OPTIONS = [
  { value: 'sunday' },
  { value: 'monday' },
  { value: 'tuesday' },
  { value: 'wednesday' },
  { value: 'thursday' },
  { value: 'friday' },
  { value: 'saturday' },
] as const;

export type WeekOptionValues = (typeof WEEK_DAY_OPTIONS)[number]['value'];

// Hour options ordered from evening to early morning (17:00 - 05:00 UTC)
// These hours are outside Oslo work hours per CronHour type
export const HOUR_OPTIONS = [
  { label: '17:00', value: '17' },
  { label: '18:00', value: '18' },
  { label: '19:00', value: '19' },
  { label: '20:00', value: '20' },
  { label: '21:00', value: '21' },
  { label: '22:00', value: '22' },
  { label: '23:00', value: '23' },
  { label: '00:00', value: '0' },
  { label: '01:00', value: '1' },
  { label: '02:00', value: '2' },
  { label: '03:00', value: '3' },
  { label: '04:00', value: '4' },
  { label: '05:00', value: '5' },
] as const;

export type HourOptionValue = (typeof HOUR_OPTIONS)[number]['value'];

export const SCHEDULE_TYPE_OPTIONS = [
  { value: 'nightly' },
  { value: 'weekly' },
] as const;

export type ScheduleType = (typeof SCHEDULE_TYPE_OPTIONS)[number]['value'];

export type ScheduleState =
  | {
      scheduleType: 'weekly';
      weekDay: WeekOptionValues;
      hour: HourOptionValue;
    }
  | {
      scheduleType: 'nightly';
      hour: HourOptionValue;
    };
